import gql from 'graphql-tag';

export default gql`
    query GetLoadManagementLoadListCSV($input: GetFilteredLoadListInput) {
        getLoadManagementLoadListCSV(input: $input) {
            csv
        }
    }
`;
